/* CreepyGoth PDP V2 — presentation-only helpers.
   Does not touch cart/variant/checkout logic; only hides/reorders already
   server-rendered DOM nodes for diversity and graceful empty-states. */
(function () {
  function diversifyYouMayAlsoLike() {
    // Category diversity itself is now guaranteed server-side (see
    // sections/related-products.liquid); this just removes any accidental
    // overlap with what Complete the Look already showed for this product.
    var ctlIds = Array.prototype.slice
      .call(document.querySelectorAll('[data-complete-the-look] [data-product-id]'))
      .map(function (el) { return el.getAttribute('data-product-id'); });
    if (!ctlIds.length) return;

    var yamlItems = document.querySelectorAll('.cg-yaml__item[data-product-id]');
    yamlItems.forEach(function (item) {
      var id = item.getAttribute('data-product-id');
      if (ctlIds.indexOf(id) !== -1) {
        item.style.display = 'none';
      }
    });
  }

  function hideEmptyGlobalReviews() {
    var section = document.querySelector('[data-cg-global-reviews]');
    if (!section) return;
    var wrapper = section.querySelector('.jdgm-carousel-wrapper');
    if (!wrapper) { section.classList.add('cg-empty-hide'); return; }

    // Judge.me hydrates this container asynchronously; give it a moment, then
    // check whether it actually produced content. If not, hide the section
    // rather than show an empty shell.
    setTimeout(function () {
      var hasContent = wrapper.children && wrapper.children.length > 0;
      if (!hasContent) {
        section.classList.add('cg-empty-hide');
      }
    }, 3000);
  }

  function init() {
    diversifyYouMayAlsoLike();
    hideEmptyGlobalReviews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
